<ng-container *ngIf="contents">
    <div *ngIf="contents.length > 0" class="associated-content pb-6">
        <isav-page-content class="is-relative">
            <h2 class="title is-2">Associated content</h2>
            <table isav-table [data]="data" class="is-fullwidth">
                <ng-container isavColumnDef="title">
                    <th
                        class="has-action"
                        isav-header-cell
                        *isavHeaderCellDef
                        (click)="sort('title')"
                    >
                        Title
                        <ng-container *ngIf="orderBy === 'title'">
                            <ng-container *ngTemplateOutlet="chevron"></ng-container>
                        </ng-container>
                    </th>
                    <td isav-cell *isavCellDef="let row">
                        <ng-container *ngIf="row.externalLink?.url; else internal">
                            <a target="_blank" [href]="row.externalLink?.url">{{ row.title }}</a>
                        </ng-container>
                        <ng-template #internal>
                            <a [routerLink]="viewLink(row)" [queryParams]="{ iri: row['@id'] }">
                                {{ row.title }}
                            </a>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container isavColumnDef="type">
                    <th
                        class="has-action"
                        isav-header-cell
                        *isavHeaderCellDef
                        (click)="sort('type')"
                    >
                        Type
                        <ng-container *ngIf="orderBy === 'type'">
                            <ng-container *ngTemplateOutlet="chevron"></ng-container>
                        </ng-container>
                    </th>
                    <td isav-cell *isavCellDef="let row">{{ row.type | isavSpace }}</td>
                </ng-container>

                <tr isav-header-row *isavHeaderRowDef></tr>
                <tr isav-row *isavRowDef="let row; columns: ['title', 'type']"></tr>
            </table>

            <div class="has-text-right">
                <a *ngIf="contents.length > shownContents" (click)="showAll(contents.length)">
                    View all contents ({{ contents.length }})
                </a>
                <a *ngIf="shownContents > 10" (click)="hide()"> Hide </a>
            </div>
            <isav-loader-overlay *ngIf="loading"></isav-loader-overlay>
        </isav-page-content>
    </div>
</ng-container>

<ng-template #chevron>
    <isav-icon *ngIf="sortBy === 'asc'" icon="chevron-down"></isav-icon>
    <isav-icon *ngIf="sortBy === 'desc'" icon="chevron-up"></isav-icon>
</ng-template>
